import { useNuxtApp } from "#app";
export function useOpenFetchOptions(arg1, arg2) {
  const { $openFetch } = useNuxtApp();
  const [options = {}, name] = typeof arg1 === "string" ? [arg2, arg1] : [arg1];
  if (name) {
    $openFetch[name] = typeof options === "function" ? options($openFetch[name]) : {
      ...$openFetch[name],
      ...options
    };
    return;
  }
  Object.keys($openFetch).forEach((_name) => useOpenFetchOptions(_name, options));
}
